import { render, staticRenderFns } from "./LogDialog.vue?vue&type=template&id=387f967c"
import script from "./LogDialog.vue?vue&type=script&lang=js"
export * from "./LogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports